import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
// import Layout from '../components/Layout'
import HomePageTemplate from '../components/HomePageTemplate'

const HomePage = ({ data }) => {
  const { frontmatter } = data.markdownRemark

  return (
      <HomePageTemplate
        title={frontmatter.title}
        welcomeMessage={frontmatter.welcomeMessage}
        welcomeAside={frontmatter.welcomeAside}
      />
  )
}

HomePage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    })
  }),
}

export default HomePage

export const homePageQuery = graphql`
  query HomePage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        welcomeMessage
        welcomeAside {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`